module.exports = __webpack_public_path__ + "images/category_lp/retro_game/assessment_achievements/4_c6ec102d3799775abbb4b8c978d4e0d1.png";